import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { useClient } from '../../client-api';
import { type ClientPackageAppendixDocumentDto, createGenericDocuments } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useAddGenericDocuments = (
    clientId?: number,
): UseMutationResult<ClientPackageAppendixDocumentDto[], AxiosError, { packageId: number; files: File[] }> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: ({ packageId, files }) =>
            createGenericDocuments({
                body: { pdfFiles: files },
                path: { id: packageId },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                },
            }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.clientPackagesForClient(clientId ?? client?.id) });
            showSuccessToast(t('clientPackageGenericDocumentsUploadSuccess'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('clientPackageGenericDocumentsUploadFailure') }),
    });
};
